import React, { useContext, useState } from "react";
import { InfiniteTable } from "../../../../components";
import LeadsItem from "./LeadsItem";
import "./quote-leads.scss";

const LeadsList = ({ product_id }) => {
  const headers = ["Status", "Date", "Sender", "Condition", "Year"];

  return (
    <div className="leads-list">
      <div
        className="quote-list-view"
        id="scrollableDiv"
        style={{
          overflow: "auto",
          display: "flex",
          flexDirection: "column-reverse",
        }}
      >
        <InfiniteTable
          key={{}}
          height={500}
          className="quotes-list"
          fetchUrl={`/api/requests/leads/quote-leads`}
          fetchLimit={5}
          // firstPageOnly
          fetchParams={{
            filters: {
              product_id: product_id,
            },
          }}
          emptyText="There are no leads yet"
          headers={headers}
          onSelectClick={{}}
          RowComponent={LeadsItem}
          rowComponentProps={{}}
          scrollableTarget="scrollableDiv"
        />
      </div>
    </div>
  );
};

export default LeadsList;
